import React from 'react';

const StonewallLogo = ({ className = "h-10 w-10" }) => {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/Stonewall_logo.png`}
      alt="Stonewall Logo"
      className={className}
      style={{ filter: 'brightness(0) saturate(100%) invert(36%) sepia(98%) saturate(1200%) hue-rotate(201deg) brightness(97%) contrast(101%)' }}
    />
  );
};

export default StonewallLogo;
